__turbopack_context__.v({
  "legalScroll": "terms-step-module__tYEhfa__legalScroll",
});
